<template>
  <v-form ref="form" lazy-validation @submit.prevent="onSubmit()">
    <v-container fluid>
      <v-row>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-text-field
            v-model="solicitacao.solicitanteNome"
            placeholder="Digite seu nome"
            label="Nome *"
            :rules="[rules.required]"
            filled
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col :md="4" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-text-field
            v-model="solicitacao.cep"
            placeholder="Digite seu cep"
            label="Cep"
            v-mask="'#####-###'"
            filled
            rounded
            dense
            masked="false"
            @input="searchCep"
            :loading="isLoading"
            :rules="[rules.cep]"
          >
            <template v-slot:progress>
              <v-progress-circular
                v-if="isLoading"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </template>
          </v-text-field>
        </v-col>
        <v-col :md="8" :sm="12" :xs="12" cols="12" class="pt-0 pb-3">
          <v-text-field
            v-model="solicitacao.endereco"
            placeholder="Ex.: Rua Evangelista Silva, N 345"
            label="Logradouro *"
            :rules="[rules.required]"
            filled
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0 pb-5">
          <v-autocomplete
            v-model="solicitacao.municipio"
            :items="municipios"
            :search-input.sync="searchMunicipios"
            :item-text="'nome'"
            :item-value="selectCidade"
            :rules="[rules.required]"
            cache-items
            hide-no-data
            hide-details
            label="Cidade *"
            placeholder="Digite sua cidade"
            filled
            rounded
            dense
          ></v-autocomplete>
        </v-col>
        <!-- <v-col :md="6" :sm="12" :xs="12" cols="12">
          <v-text-field
            v-model="solicitacao.estado"
            placeholder="Digite seu estado"
            label="Estado *"
            :rules="[rules.required]"
            filled
            rounded
            dense
          ></v-text-field>
        </v-col> -->
        <v-col :md="6" :sm="12" :xs="12" cols="12" class="pt-5">
          <v-text-field
            v-model="solicitacao.telefone"
            placeholder="Digite seu telefone"
            label="Telefone *"
            :rules="[rules.required]"
            v-mask="'(##) #####-####'"
            filled
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col :md="6" :sm="12" :xs="12" cols="12" class="pt-5">
          <v-text-field
            v-model="solicitacao.email"
            placeholder="Digite seu email"
            label="Email *"
            :rules="[rules.required, rules.email]"
            filled
            rounded
            dense
            type="email"
          ></v-text-field>
        </v-col>
        <v-col :offset-md="10" class="pt-0 pb-0">
          <v-btn depressed block large color="primary" type="submit">
            Próximo
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import { Subject, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  map,
  switchMap,
  delay
} from "rxjs/operators";

import CepService from "@/services/cep.service";
import MunicpioService from "@/services/municipio.service";

import SolicitacaoModule from "@/store/modules/solicitacao";

export default {
  directives: {
    mask
  },
  data() {
    return {
      isLoading: false,
      patternCep: /^[0-9]{2}[0-9]{3}-[0-9]{3}$/,
      subjectCep: null,
      steps: 3,
      form: {},
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail inválido.";
        },
        required: value => !!value || "Esse campo deve ser preenchido",
        cep: value => {
          const pattern = this.patternCep;
          return pattern.test(value) || "Cep inválido.";
        }
      },
      municipios: [],
      searchMunicipios: null
    };
  },
  mounted() {
    this.loadMunicipios();
    this.cepSubject();
    this.mountSolicitacao();
  },
  methods: {
    mountSolicitacao() {
      this.solicitacao = {
        estado: {
          id: 6,
          nome: "Ceará"
        },
        area: {},
        agenteRegulado: {},
        municipio: {},
        tipoSolicitacao: {},
        // solicitanteNome: "",
        // cep: "",
        // email: "",
        // endereco: "",
        // telefone: "",
        recaptcha: null,
        entrouEmContato: false
        // unidadeConsumidoraNumero: "",
        // mensagem: "",
        // pretensao: "",
        // viagemHoraDeInicio: "",
        // viagemLocalDeInicio: "",
        // viagemLocalDeFim: "",
        // viagemNomeDaLinha: ""
      };
    },
    selectCidade(event) {
      return { id: event.id, nome: event.nome };
    },
    searchCep(value) {
      this.subjectCep.next(value);
    },
    cepSubject() {
      this.subjectCep = new Subject();
      this.subjectCep
        .pipe(debounceTime(500))
        .pipe(distinctUntilChanged())
        .pipe(tap(value => (this.isLoading = true)))
        .pipe(
          switchMap(value => {
            const pattern = this.patternCep;
            const validCep = pattern.test(value);
            if (!validCep) {
              return of({ error: "Cep invalido" });
            }
            return CepService.find(value);
          })
        )
        .pipe(delay(500))
        .subscribe(
          res => {
            this.isLoading = false;
            if (!res.error) {
              const { logradouro, uf, localidade } = res.data;
              this.solicitacao.endereco = logradouro;
              const cidadeFiltered = this.municipios.filter(
                m => m.nome.toLowerCase() === localidade.toLowerCase()
              );
              this.solicitacao.municipio = cidadeFiltered
                ? cidadeFiltered[0]
                : undefined;
              SolicitacaoModule.changeSolicitacao(this.solicitacao);
            }
          },
          error => {
            this.isLoading = false;
          }
        );
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        SolicitacaoModule.setstepperOneValid(isValid);
        this.nextStep(1);
        this.$vuetify.goTo(0);
      }
    },
    nextStep(n) {
      if (n === this.steps) {
        SolicitacaoModule.setCurrentStep(1);
      } else {
        SolicitacaoModule.setCurrentStep(n + 1);
      }
    },
    loadMunicipios() {
      MunicpioService.getAllSoa().subscribe(
        res => {
          this.municipios = res;
        },
        error => {}
      );
    }
  },
  computed: {
    solicitacao: {
      get: () => SolicitacaoModule.solicitacao,
      set: value => SolicitacaoModule.setSolicitacao(value)
    }
  }
};
</script>

<style scoped lang="scss">
.v-progress-circular {
  height: 22px !important;
  width: 22px !important;
  top: 16px !important;
}
</style>
